ToggleClass = LP.module 'ToggleClass'
ToggleClass.site = ->
  $('body').on 'click', '[data-toggle=class]', (e) ->
    el = $(this)
    $(el.data('target')).toggleClass el.data('class')
